export default function CStatements() {
  return <h2>C Statements</h2>;
}
